import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  SxProps,
  ToggleButton
} from '@mui/material';

export interface ToggleButtonGroupButton {
  id: string;
  label: string;
  icon?: React.ReactNode;
}

export interface ToggleButtonGroupProps {
  buttons: ToggleButtonGroupButton[];
  value: string;
  onChange: (value: string) => void;
}

const toggleButtonsSx: {
  container: SxProps;
  button: SxProps;
} = {
  container: {
    display: 'flex'
  },
  button: {
    width: '50px'
  }
};

const ToggleButtonGroup = ({
  buttons,
  value,
  onChange
}: ToggleButtonGroupProps) => {
  return (
    <MuiToggleButtonGroup
      size="small"
      exclusive
      // sx={toggleButtonsSx.container}
      sx={{
        '& > :first-child': {
          borderTopLeftRadius: 30,
          borderBottomLeftRadius: 30
        },
        '& > :last-child': {
          borderTopRightRadius: 30,
          borderBottomRightRadius: 30
        }
      }}
      value={value}
      onChange={(_, value) => {
        if (value) {
          onChange(value);
        }
      }}
    >
      {buttons.map(button => (
        <ToggleButton
          value={button.id}
          key={button.id}
          sx={toggleButtonsSx.button}
        >
          {button.icon ?? button.label}
        </ToggleButton>
      ))}
    </MuiToggleButtonGroup>
  );
};

export default ToggleButtonGroup;
